//-------------------------------------------------------------------------------------
//
//	GfxRender3D
//
//		
//
//-------------------------------------------------------------------------------------

//-------------------------------------------------------------------------------------
//	Imports
//-------------------------------------------------------------------------------------
import { Transform, Projection3D } from "../../VectorUtilsJS/src/VectorUtilLib.js";
import { GfxDrawing, GfxPath } from "../../GfxContainer/src/GfxDrawing.js";
import { GfxRender } from "../../GfxContainer/src/GfxRender.js";
import { GenerateDXF, GenerateSVG } from "../../VectorUtilsJS/src/VectorFileLib.js";


//-------------------------------------------------------------------------------------
//	Gfx Render 3D
//-------------------------------------------------------------------------------------
var GfxRender3D = (function() {

	var RenderGfxDrawing = function(context, gfxDrawing, viewTransform, viewProjection)
	{
		var pathCount = gfxDrawing.GetPathCount();
		
		for (var pathIdx = 0; pathIdx < pathCount; pathIdx++)
		{
			let gfxPath = gfxDrawing.GetGfxPath(pathIdx);
			let gfxSettings = gfxDrawing.GetPathSettings(pathIdx);
			
			if (gfxSettings.strokePath)
			{
				context.strokeStyle = gfxSettings.strokeColor;
				context.lineWidth = viewTransform.scaleNum(gfxSettings.strokeWidth);
			}
			
			if (gfxSettings.fillPath)
			{
				context.fillStyle = gfxSettings.fillColor;
			}
			
			if (!gfxPath.Is2D())
				RenderGfxPath(context, gfxPath, viewTransform, viewProjection, {strokePath:gfxSettings.strokePath, fillPath:gfxSettings.fillPath} );
			else
				GfxRender.RenderGfxPath(context, gfxPath, viewTransform, {strokePath:gfxSettings.strokePath, fillPath:gfxSettings.fillPath} );
		}
	}
	
	
	var RenderGfxPath = function(context, gfxPath, viewTransform, viewProjection, actions = { strokePath: true })
	{
		context.beginPath();
	
		for (var i = 0; gfxPath != undefined && i < gfxPath.GetOpCount(); i++)
		{
			let op = gfxPath.GetOp(i);
			
			if (op.op == GfxPath.Op.NOOP)
			{
			}
			else if (op.op == GfxPath.Op.MOVETO)
			{
				MoveTo(context, op.pt, viewTransform, viewProjection);
			}
			else if (op.op == GfxPath.Op.LINETO)
			{
				LineTo(context, op.pt, viewTransform, viewProjection);
			}
			else if (op.op == GfxPath.Op.ARC)
			{
				Arc(context, op.pt, op.r, op.start, op.end, op.ccw, viewTransform, viewProjection);
			}
			else if (op.op == GfxPath.Op.CIRCLE)
			{
				Circle(context, op.pt, op.r, viewTransform, viewProjection);
			}
			else if (op.op == GfxPath.Op.CLOSE)
			{
				context.closePath();
			}
			else if (op.op == GfxPath.Op.TEXT)
			{
				Text(context, op.pt, op.str, viewTransform, viewProjection);
			}
		}
	
		if (actions.fillPath)
			context.fill();
	
		if (actions.strokePath)
			context.stroke();
	}

	var MoveTo = function(context, pt, xform, viewProjection)
	{
		var vpt = viewProjection.Map3Dto2D(pt);
		GfxRender.MoveTo(context, vpt, xform);
	}

	var LineTo = function(context, pt, xform, viewProjection)
	{
		var vpt = viewProjection.Map3Dto2D(pt);
		GfxRender.LineTo(context, vpt, xform);
	}

	var Arc = function(context, pt, radius, startAngle, endAngle, ccw, xform, viewProjection)
	{
		//var xpt = (xform != undefined) ? xform.xfrm(pt) : pt;
		//var xr  = (xform != undefined) ? xform.scaleNum(radius) : radius;
		//context.arc(xpt.x, xpt.y, xr, startAngle, endAngle, ccw);
	}
	
	var Circle = function(context, pt, radius, xform, viewProjection)
	{
		var vpt = viewProjection.Map3Dto2D(pt);
		GfxRender.Circle(context, vpt, radius, xform);
	}
	
	var Text = function(context, pt, str, xform, viewProjection)
	{
		var vpt = viewProjection.Map3Dto2D(pt);
		GfxRender.Text(context, vpt, str, xform);
	}
	
	
	//-------------------------------------------------------------------------------------
	//	API
	//-------------------------------------------------------------------------------------
	return {
		RenderGfxPath:			RenderGfxPath,
		RenderGfxDrawing:		RenderGfxDrawing,
	};
}());



//-------------------------------------------------------------------------------------
//	Public
//-------------------------------------------------------------------------------------
export { GfxRender3D };

